import CabBoxOpenedImage from './CabBoxOpenedImage';

export default CabBoxOpenedImage;
